import $ from 'jquery'
export default{
  install (Vue, options) {
    Vue.prototype.isHttps = function () {
      return window.location.protocol === 'https:'
    }
    Vue.prototype.serviceUrl = function (path) {
      return process.env.SERVICE_URL + path;
    }
    Vue.prototype.pageUrl = function (path) {
      return '/' + this.$route.params.shopid + '/' + path;
    }
    Vue.prototype.cdnUrl = function (path) {
      return process.env.CDN_URL + '/' + path;
    }
    Vue.prototype.pageFn = function (page) {
      return 'javascript:void(0);'
    }
    Vue.prototype.dateRangePickerOptions = {
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 1,
      timePickerSeconds: true,
      locale: {
        format: 'YYYY-MM-DD HH:mm:ss',
        applyLabel: '确定',
        cancelLabel: '清除',
        customRangeLabel: 'Custom',
        daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        opens: 'left'
      }
    }
    Vue.prototype.dateTimePickerOptions = {
      singleDatePicker: true,
      showClear: true,
      locale: {
        format: 'YYYY-MM-DD',
        applyLabel: '确定',
        cancelLabel: '清除',
        customRangeLabel: 'Custom',
        daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        opens: 'left'
      }
    }
    Vue.prototype.fadeIn = function (dom, speed = 'normal') {
      dom.fadeIn(speed).removeClass('hidden').removeClass('hide');
    }
    Vue.prototype.alert = function (text, type = 1, isAutoHide = true) {
      // 自定义alert
      let $tips = $('.js-alert-tips')
      let $textDom = $tips.find('.inner-text')
      let $classText = 'alert-info alert-danger'
      $textDom.html(text);
      $textDom.removeClass($classText);
      if (type === 1) {
        // success alert
        $textDom.addClass('alert-info');
      } else if (type === 2) {
        // danger alert
        $textDom.addClass('alert-danger');
      } else {
        $textDom.addClass('alert-info');
      }
      this.fadeIn($tips);
      if (isAutoHide !== false) {
        setTimeout(() => {
          $tips.fadeOut();
        }, 5000);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/utils.js